import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createDeliverable } from "./api";
import {
  invalidateAllDeliverablesQueries,
  toJunctionRows,
  uploadFiles,
} from "../query";
import {
  FILES_FIELD,
  FILES_JUNCTION_KEY,
  SKILLS_FIELD,
  SKILLS_JUNCTION_KEY,
} from "../../constants";

export function useCreateDeliverable() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const { [FILES_FIELD]: files = [], [SKILLS_FIELD]: skills = [], ...rest } = item;
      const fileIds = await uploadFiles(files);
      const payload = {
        ...Object.fromEntries(
          Object.entries(rest).filter(([, v]) => v !== "" && v != null)
        ),
        [FILES_FIELD]: toJunctionRows(fileIds, FILES_JUNCTION_KEY),
        [SKILLS_FIELD]: toJunctionRows(skills, SKILLS_JUNCTION_KEY),
      };
      return createDeliverable({ item: payload });
    },
    onSuccess: () => {
      toast.success("Deliverable Created Successfully");
      invalidateAllDeliverablesQueries();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
